import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import type { GameCardProps } from "@/interfaces";

const GameCard = ({ img, title, price, tax, total }: GameCardProps) => (
  <section className="w-full px-5 justify-between mb-[50px] text-[#212121] items-start">
    <div className="flex mb-8 landscape:mb-4 gap-[10px]">
      <Avatar>
        <AvatarImage src={img} />
        <AvatarFallback>GAME</AvatarFallback>
      </Avatar>

      <div className="flex flex-col justify-between w-full leading-none gap-1.5">
        <div className="flex items-end justify-between w-full">
          <h1 className="text-[18px] font-medium">{title}</h1>
          <p className="text-[14px]">{price}</p>
        </div>
        <div className="flex items-end text-[14px] justify-between w-full h-full">
          <p className="flex items-start gap-[5px]">Tax </p>
          <p>{tax}</p>
        </div>
        <div className="flex items-center text-[18px] justify-between w-full h-full font-medium landscape:hidden">
          <p>Total</p>
          <p>{total}</p>
        </div>
      </div>
    </div>
    <div className="flex items-center text-[18px] justify-between w-full h-full font-medium portrait:hidden">
      <p>Total</p>
      <p>{total}</p>
    </div>
  </section>
);

export default React.memo(GameCard);
